import GridCard from 'obvio/Organizations/Collection/Cards/GridCard'
import styled from 'styled-components'
import {useUserOrganizations} from 'obvio/Organizations/UserOrganizationsProvider'
import React from 'react'
import ListCard from 'obvio/Organizations/Collection/Cards/ListCard'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'

export default function Collection(props: {showingListView: boolean}) {
  const {showingListView} = props
  const {organizations, loading, searchQuery} = useUserOrganizations()

  // show loading only on first load
  if (loading && organizations.length === 0 && searchQuery === '') {
    return (
      <LoaderContainer>
        <FullPageLoader />
      </LoaderContainer>
    )
  }

  const empty = organizations.length === 0
  if (empty) {
    if (searchQuery !== '') {
      return <EmptySearchResultsMessage />
    }

    return <EmptyCreatedOrganizationsMessage />
  }

  if (showingListView) {
    return (
      <LoadingContent $loading={loading}>
        {organizations.map((o, idx) => (
          <ListCard key={o.id} organization={o} index={idx} />
        ))}
      </LoadingContent>
    )
  }

  return (
    <LoadingContent $loading={loading}>
      <Grid>
        {organizations.map((o) => (
          <GridCard key={o.id} organization={o} />
        ))}
      </Grid>
    </LoadingContent>
  )
}

function EmptySearchResultsMessage() {
  return (
    <EmptyBox>
      <p>No organizations match your search</p>
    </EmptyBox>
  )
}

function EmptyCreatedOrganizationsMessage() {
  return (
    <EmptyBox>
      <p>No organizations have been created</p>
    </EmptyBox>
  )
}

const column = `minmax(270px, auto)`

const LoadingContent = styled.div<{$loading: boolean}>`
  opacity: ${(props) => (props.$loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$loading ? 'none' : 'auto')};
  transition: opacity 200ms;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-gap: ${(props) => props.theme.spacing[8]};

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    grid-template-columns: ${column} ${column};
    grid-template-rows: auto auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: ${column} ${column} ${column};
    grid-template-rows: auto auto auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
    grid-template-columns: ${column} ${column} ${column} ${column};
    grid-template-rows: auto auto auto auto;
  }
`

const EmptyBox = styled.div`
  margin-top: ${(props) => props.theme.spacing[8]};
  text-align: center;
`

const LoaderContainer = styled.div`
  position: relative;
  height: 400px;
`
